import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { AUTH_LOGOUT_SUCCESS, LOAD_SUBSCRIPTIONS_REQUEST, LOAD_SUBSCRIPTIONS_SUCCESS, LOAD_SUBSCRIPTIONS_ERROR, LOAD_SUBSCRIPTION_REQUEST, LOAD_SUBSCRIPTION_SUCCESS, LOAD_SUBSCRIPTION_ERROR, CANCEL_SUBSCRIPTION_REQUEST, CANCEL_SUBSCRIPTION_SUCCESS, CANCEL_SUBSCRIPTION_ERROR, SKIP_SUBSCRIPTION_REQUEST, SKIP_SUBSCRIPTION_SUCCESS, SKIP_SUBSCRIPTION_ERROR, UPDATE_SUBSCRIPTION_REQUEST, UPDATE_SUBSCRIPTION_SUCCESS, UPDATE_SUBSCRIPTION_ERROR, RESUME_SUBSCRIPTION_REQUEST, RESUME_SUBSCRIPTION_SUCCESS, RESUME_SUBSCRIPTION_ERROR, PAUSE_SUBSCRIPTION_REQUEST, PAUSE_SUBSCRIPTION_SUCCESS, PAUSE_SUBSCRIPTION_ERROR } from '../actions/types';
import { addToList, removeFromList, removeFromMap } from './utils/thunk';
import initialState from '../store/initial-state';
var subscriptions = function subscriptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.subscriptions;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case AUTH_LOGOUT_SUCCESS:
      return {
        data: {},
        loading: [],
        isLoaded: false
      };
    case LOAD_SUBSCRIPTIONS_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: ['list'],
          success: [],
          error: null
        });
      }
    case LOAD_SUBSCRIPTION_REQUEST:
    case CANCEL_SUBSCRIPTION_REQUEST:
    case SKIP_SUBSCRIPTION_REQUEST:
    case UPDATE_SUBSCRIPTION_REQUEST:
    case RESUME_SUBSCRIPTION_REQUEST:
    case PAUSE_SUBSCRIPTION_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          success: removeFromList({
            list: state.success,
            key: action.payload
          }),
          loading: addToList({
            list: state.loading,
            key: action.payload
          }),
          error: removeFromMap({
            map: state.error,
            key: action.payload
          })
        });
      }
    case LOAD_SUBSCRIPTIONS_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          success: ['list'],
          loading: [],
          data: action.payload.data.reduce(function (acc, sub) {
            return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, sub.id, sub));
          }, {}),
          error: null
        });
      }
    case LOAD_SUBSCRIPTION_SUCCESS:
    case CANCEL_SUBSCRIPTION_SUCCESS:
    case SKIP_SUBSCRIPTION_SUCCESS:
    case UPDATE_SUBSCRIPTION_SUCCESS:
    case RESUME_SUBSCRIPTION_SUCCESS:
    case PAUSE_SUBSCRIPTION_SUCCESS:
      {
        var id = action.payload.data.id;
        var newData = _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, id, action.payload.data));
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: removeFromList({
            list: state.loading,
            key: id
          }),
          success: addToList({
            list: state.success,
            key: id
          }),
          data: newData,
          error: removeFromMap({
            map: state.error,
            key: id
          })
        });
      }
    case LOAD_SUBSCRIPTIONS_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          success: [],
          loading: [],
          data: {},
          error: {
            list: action.payload
          }
        });
      }
    case LOAD_SUBSCRIPTION_ERROR:
    case CANCEL_SUBSCRIPTION_ERROR:
    case SKIP_SUBSCRIPTION_ERROR:
    case UPDATE_SUBSCRIPTION_ERROR:
    case RESUME_SUBSCRIPTION_ERROR:
    case PAUSE_SUBSCRIPTION_ERROR:
      {
        var _action$payload = action.payload,
          _id = _action$payload.id,
          error = _action$payload.error;
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: removeFromList({
            list: state.loading,
            key: _id
          }),
          success: removeFromList({
            list: state.success,
            key: _id
          }),
          error: _objectSpread(_objectSpread({}, state.error), {}, _defineProperty({}, _id, error))
        });
      }
    default:
      return state;
  }
};
export default subscriptions;